// T270(6) — one stat, a value and an optional hint.
export default function StatCard({ title, value, hint, hintFull }) {
  // hintFull (optional): a long-form version of the hint that goes in a
  // native browser tooltip without stretching the card. Used by
  // "Sources active" where listing 70+ source names would blow the
  // card height.
  return (
    <div className="rounded-xl border border-slate-800 bg-slate-900/50 p-4">
      <div className="text-xs uppercase tracking-wide text-slate-500">{title}</div>
      <div className="mt-1 text-2xl font-semibold text-slate-200">{value}</div>
      {hint && (
        <div
          className="mt-1 truncate text-xs text-slate-500"
          title={hintFull || (typeof hint === 'string' ? hint : undefined)}
        >
          {hint}
        </div>
      )}
    </div>
  );
}
